function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import Box from './Box';
const DescriptionGridTerm = /*#__PURE__*/React.memo(props => /*#__PURE__*/React.createElement(Box, _extends({
  __css: {
    fontSize: 0,
    textTransform: 'uppercase',
    color: 'gray.7',
    lineHeight: 1,
    mb: 1,
    fontWeight: 'normal'
  }
}, props)));
DescriptionGridTerm.propTypes = {};
DescriptionGridTerm.defaultProps = {};
DescriptionGridTerm.displayName = 'DescriptionGridTerm';
export default DescriptionGridTerm;